import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { Navbar } from './components/navbar.component';
import { Home } from './pages/home.page';
import { CollectionPage } from './pages/collection.page';
import { TrunkShowsPage } from './pages/trunkShows.page';
import { AboutUsPage } from './pages/aboutUs.page';
import { BridalPage } from './pages/bridal.page';
import { BijouxPage } from './pages/bijoux.page';
import { CelebritiesPage } from './pages/celebrities.page';
import { Footer } from './components/footer.component';
import './App.css';

function App() {
  return (
    <div className="App">
       <Navbar/>
       <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="collection/:slug"
            element={<CollectionPage />}
          />
          <Route path="trunkshows" element={<TrunkShowsPage />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="bijoux" element={<BijouxPage />} />
          <Route path="bridal" element={<BridalPage />} />
          <Route path="celebrities" element={<CelebritiesPage />} />
       </Routes>
       <Footer />
    </div>
  );
}

export default App;
